<template>
  <div
    class="product-card__image flex justify-center items-center"
  >
    <TwicpicsImage
      :src="image"
      :alt="altText"
      :width="productCardImageWidth"
      :height="productCardImageHeight"
    />
  </div>
</template>

<script lang="ts">

import { PRODUCT_CARD } from '~~/constants/productCard';

export default defineComponent({
  name: 'ProductCardGallery',

  props: {
    image: {
      type: String,
      required: true,
    },
    altText: {
      type: String,
      default: '',
    },
  },
  setup() {

    const activeIndex: Ref<number> = ref(0);

    return {
      activeIndex,
      productCardImageWidth: PRODUCT_CARD.IMAGE_WIDTH,
      productCardImageHeight: PRODUCT_CARD.IMAGE_HEIGHT,
    };
  
  },
});

</script>
